"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const util_1 = require("../../util");
const FeatureRendererType_1 = __importDefault(require("./FeatureRendererType"));
const RpcRenderedSvgGroup_1 = __importDefault(require("./RpcRenderedSvgGroup"));
class CircularChordRendererType extends FeatureRendererType_1.default {
    constructor() {
        super(...arguments);
        this.supportsSVG = true;
    }
    deserializeResultsInClient(res, args) {
        const deserializedFeatures = new Map(res.features.map(f => util_1.SimpleFeature.fromJSON(f)).map(f => [f.id(), f]));
        // if we are rendering svg, we skip hydration
        if (args.exportSVG) {
            // only return the res if the renderer explicitly has
            // this.supportsSVG support to avoid garbage being rendered in SVG
            // document
            return {
                ...res,
                features: deserializedFeatures,
                blockKey: 'circularChord',
                html: this.supportsSVG
                    ? res.html
                    : '<text y="12" fill="black">SVG export not supported for this track</text>',
            };
        }
        // hydrate res using ServerSideRenderedContent
        return {
            ...res,
            features: deserializedFeatures,
            blockKey: 'circularChord',
            reactElement: (react_1.default.createElement(RpcRenderedSvgGroup_1.default, { ...args, ...res, features: deserializedFeatures, RenderingComponent: this.ReactComponent })),
        };
    }
}
exports.default = CircularChordRendererType;
